import JSX from "../../../helpers/react.js";
import RefObject = JSX.RefObject;

type OnChangeOrder = (order: 'ASC'|'DESC') => any;
export default function SortOrderButton({sortOrder, onChange, ref}: {sortOrder: 'ASC'|'DESC', onChange: OnChangeOrder, ref: RefObject<HTMLDivElement>}){
    onChange(sortOrder)

    return (
        <div ref={ref} className="sort-order-button" onClick={function(){sortOrderButtonClick.call(this, onChange);}}>
            <div data-balloon-pos="up-right" data-balloon={sortOrder==='DESC'?"По убыванию":'По возрастанию'}>
                <input type="hidden" name="sort_order" value={sortOrder==='DESC' ? 0 : 1} />
                <span className="far fa-sort-amount-down" />
            </div>
        </div>
    )
}
function sortOrderButtonClick(this: HTMLElement, onChange: OnChangeOrder) {
    const that = $(this);
    const input = that.find('input');
    if (+input.val()!) {
        that.children().attr('data-balloon', 'По убыванию');
        input.val(0)
        onChange('DESC')
    }
    else {
        that.children().attr('data-balloon', 'По возрастанию');
        input.val(1)
        onChange('ASC')
    }
}
